import React from "react";
import "./styles/services.sass";
import { Outlet, Link } from "react-router-dom";
import accident from "./img/accident.svg";
import car from "./img/car.svg";
import fireTruck from "./img/fireTruck.svg";
import wheel from "./img/wheel.svg";

const Services = () => {
  return (
    <div className='services'>
      <div>
        <img src={car} alt='samochód' />
        <h2>Naprawa samochodów osobowych</h2>
        <Link to='/osobowe'>Zobacz</Link>
      </div>
      <div>
        <img src={accident} alt='drzwi' />
        <h2>Blacharstwo samochodowe</h2>
        <Link to='/blacharstwo'>Zobacz</Link>
      </div>
      <div>
        <img src={wheel} alt='koło' />
        <h2>Wulkanizacja</h2>
        <Link offset={-11150} to='/wulkanizacja'>
          Zobacz
        </Link>
      </div>
      <div>
        <img src={fireTruck} alt='wóz strażacki' />
        <h2>Naprawa pojazdów specjalistycznych</h2>
        <Link to='/specjalistyczne'>Zobacz</Link>
      </div>
    </div>
  );
};

export default Services;
